import { User } from '@akin-home/amplify';
import {
  createMockFunctions,
  prepNewMockGraphqlRecord,
} from '@akin-home/testing';
import { createUserMutation } from '../api/mutations';

const key = 'users';

const {
  list: listMockUsers,
  listAsync: listMockUsersAsync,
  set: setMockUsers,
  get: getMockUser,
} = createMockFunctions<User>({
  key,
  find:
    ({ id }: { id?: string }) =>
    (user) =>
      user.id === id,
});

export const getMockUserByUsername = (username?: string) =>
  listMockUsers().find((user) => user.username === username);

export const prepNewMockUser = prepNewMockGraphqlRecord<User>('User');

export const seedMockUsers = (data: Omit<User, '__typename'>[]) => {
  setMockUsers(data.map(prepNewMockUser) as User[]);
};

export const createMockUser = async (
  params: Parameters<typeof createUserMutation>
) => {
  const input = params[0].input;

  if (input) {
    setMockUsers([...listMockUsers(), prepNewMockUser(input as any)]);
  }
};

export { listMockUsers, listMockUsersAsync, setMockUsers, getMockUser };
